export default __webpack_public_path__ + "static/media/custom_webhook.dab402fc.svg";